<!-- Treemap -->

<div class="flex-start-center gap-x-2 mb-6 text-base font-semibold">
    <ng-container *ngIf="chain === 'sol'">
        <img src="/assets/imgs/chains/solana.png" class="w-6 h-6" alt="" />
        <span>Solana</span>
    </ng-container>

    <ng-container *ngIf="chain === ChainEnum.BSC">
        <img src="/assets/imgs/chains/bnb.png" class="w-6 h-6" alt="" />
        <span>BNB Chain</span>
    </ng-container>

    <ng-container *ngIf="chain === ChainEnum.BASE">
        <img src="/assets/imgs/chains/base.png" class="w-6 h-6" alt="" />
        <span>Base</span>
    </ng-container>

    <ng-container *ngIf="chain === 'monad_testnet'">
        <img src="/assets/imgs/chains/monad.png" class="w-6 h-6" alt="" />
        <span>Monad Testnet</span>
    </ng-container>
</div>

<div
    class="w-full md:p-6 md:border md:border-line rounded-lg gap-0.5 flex-start-center flex-col md:flex-row md:flex-start-center min-h-[200px] h-[782px] md:h-[440px]"
    appLoading
    [loading]="loading"
>
    <ng-container *ngFor="let item of treemapList">
        <app-base-treemap
            *ngIf="(!shownDetailedTreemap || shownDetailedTreemap === item.type) && item.data.length"
            [type]="item.type"
            [data]="item.data"
            [valueType]="valueType"
            [style.width]="!shownDetailedTreemap ? (percentageMap[item.type] * 100 + '%' ): '100%'"
            class="flex-shrink-0 block max-md:!flex-1 max-md:!w-full"
            [shownDetailedTreemap]="shownDetailedTreemap"
            (shownDetailedTreemapChange)="shownDetailedTreemapChange(item.type)"
        ></app-base-treemap>
    </ng-container>

    <div *ngIf="!treemapList?.length && !loading" class="w-full h-full flex-center-center">
        <span class="text-sub-text text-sm">Wallets in this Watchlist currently have no MEME buys data.</span>
    </div>
</div>
